<script>
    import * as m from '@app/paraglide/messages.js';
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import { createEventDispatcher } from "svelte";
    import removeEvent from "@cclib/functions/eventGroups/removeEvent.js";

    const dispatch = createEventDispatcher();

    async function cutEvents() {
        try {
            if (eventGroupState[projectState.selected].selected.length > 0) {
                let textToCopy,
                    range = window?.quillEditor?.getSelection();
                if (
                    range &&
                    range.length !== 0 &&
                    eventGroupState[projectState.selected].selected.length ===
                        1
                ) {
                    textToCopy = window.quillEditor.getText(range.index, range.length);
                    window.quillEditor.deleteText(range.index, range.length);
                } else {
                    let eventsToCut = [];
                    let selectedEvents = eventGroupState[
                        projectState.selected
                    ].selected.map((selectedEvent) => {
                        return selectedEvent;
                    });

                    eventGroupState[projectState.selected].selected = [];

                    selectedEvents
                        .sort((a, b) => {
                            return b - a;
                        })
                        .forEach((eventIndex) => {
                            eventsToCut.push(
                                eventGroupState[projectState.selected].events[
                                    eventIndex
                                ],
                            );
                            eventGroupState[projectState.selected] =
                                removeEvent(
                                    eventGroupState[projectState.selected],
                                    eventIndex,
                                );
                        });

                    textToCopy = JSON.stringify(eventsToCut);
                }

                navigator.clipboard.writeText(textToCopy);

                insertHistoryAction({
                    name: "cut event(s)", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        },
                    ],
                });
            }
        } catch (err) {
            console.log(err);
            console.log(err.message);
        } finally {
            dispatch("done");
        }
    }
</script>

<a id="btnCutEvents"
   role="menuitem"
   aria-label={m.context_menu_cut_label()}
   class="dropdown-item" href="#!/"
   onclick={cutEvents}>
   {m.context_menu_cut()}
</a>
